import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import Navbar from '../navbar/navbar.comp';
import './settings.style.scss';
import { UserContext } from '../../contexts/user.context.jsx';
import Button from '../button/button.comp.jsx';
import {
    getUserDoc, postUserDoc,
    countLiveChallenges, deleteUserAndChallenges
} from '../../utils/firebase/firebase.utils.js';
import SignOut from '../../routes/signOut/signOut.comp.jsx';
import { useChannel } from '../../contexts/channel.context.jsx';

const Settings = () => {

    //Nave & Contexts
    const { userID, profileImageUrl, setCurrentUser, setUserID, setProfileImageUrl } = useContext(UserContext); // Access context functions
    const navigate = useNavigate();
    const { setSelectedChannel } = useChannel();

    //GET User Doc
    const initialDoc = {
        displayName: '',
        imageURL: profileImageUrl,  // Initialize with the current context value
        email: ''
    }
    const initialChallengesCount = 0;
    const [liveChallenges, setLiveChallenges] = useState(0)

    //Loading User
    const [userDoc, setUserDoc] = useState(initialDoc);
    const [anchor, setAnchor] = useState(null);

    useEffect(() => {
        const timer = setTimeout(async () => {
            const userDocument = await getUserDoc(userID);
            const liveChallengesCount = await countLiveChallenges(userID);

            // console.log(liveChallengesCount)

            setUserDoc(userDocument);
            setLiveChallenges(liveChallengesCount);
            setAnchor(JSON.parse(JSON.stringify(userDocument)));

        }, 200);

        return () => clearTimeout(timer);
    }, []);


    // Track Changes
    const [changes, setChanges] = useState(false)


    const sanitizeTag = (tag) => {
        return tag.toLowerCase().replace(/\s+/g, '');
    };

    //Input Changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setUserDoc(prevState => ({ ...prevState, [name]: value }));
        setChanges(true)
        if (name === 'imageURL') {
            setProfileImageUrl(value);  // Update profile image URL in context
        }
    };
    const handleTagInputChange = (e) => {
        const { name, value } = e.target;
        const sanitizedValue = sanitizeTag(value);

        setUserDoc(prevState => ({ ...prevState, [name]: sanitizedValue }));
        setChanges(true)
    };
    const handleToggleLive = () => {
        setUserDoc(prevState => ({ ...prevState, isLive: !prevState.isLive }));
        setChanges(true)
    };


    //POST User Doc
    const handleSaveChanges = async () => {
        await postUserDoc(userID, userDoc);
        setAnchor(JSON.parse(JSON.stringify(userDoc)))
        setChanges(false)
    }
    const handleCancelChanges = () => {
        setUserDoc(anchor);
        setChanges(false)
    }


    //Pop Up Views
    const [displayChannel, setDisplayChannel] = useState(false)
    const handleToggleViewChannel = () => {
        setDisplayChannel(!displayChannel);
        // console.log("display channel", displayChannel)
    }
    const [displayThumbnail, setDisplayThumbnail] = useState(false)
    const handleToggleViewThumbnail = () => {
        setDisplayThumbnail(!displayThumbnail);
    }
    const [displayAbout, setDisplayAbout] = useState(false)
    const handleToggleViewAbout = () => {
        setDisplayAbout(!displayAbout);
        // console.log("display about", displayAbout)
    }

    //About Pop Up
    const handleOpenLink = (url) => {
        window.open(url, '_blank');
    };

    //Settings
    const [signOutPopUp, setSignOutPopUp] = useState(false)
    const handleSignOutClicked = () => {
        setSignOutPopUp(true)
    }
    const handleCloseSignOut = () => {
        setSignOutPopUp(false)
        setDeleteAccountPopUp(false)
    }

    const handleGoToChannel = (channel) => {
        setSelectedChannel(channel);
        navigate(`/channel`);
    }

    const [deleteAccountPopUp, setDeleteAccountPopUp] = useState(false)
    const handleDeleteAccountClicked = () => {
        setDeleteAccountPopUp(true)
    }

    const handleDeleteThisAccount = async () => {
        try {
            // Call the function to delete the user and their associated challenges
            await deleteUserAndChallenges(userDoc.id);

            // Reset the user context
            setCurrentUser(null); // Reset currentUser
            setUserID(null); // Reset userID
            setProfileImageUrl('https://static.vecteezy.com/system/resources/thumbnails/002/318/271/small_2x/user-profile-icon-free-vector.jpg'); // Reset profileImageUrl to default

            // Navigate to a different route after deletion, like the home or sign-up page
            navigate('/');
        } catch (error) {
            console.error("Error deleting account:", error);
        }
    }

    return (
        <div>
            <Navbar option={5} />

            {/* Heading */}
            <div className='section tight' style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <h1 style={{ textAlign: 'left' }}>Settings</h1>

                {/* Save & Cancel Buttons */}
                <div
                    style={{ display: 'flex', justifyContent: 'flex-end' }}
                >
                    {
                        changes ? (
                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                                <Button text={'Cancel'} option={'yellow'} onClick={handleCancelChanges} />
                                <Button text={'Save'} option={'green'} onClick={handleSaveChanges} />
                            </div>
                        ) : (
                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                                <Button text={'Cancel'} option={'inactive'} />
                                <Button text={'Save'} option={'inactive'} />
                            </div>
                        )
                    }
                </div>
            </div>

            {/* Profile Settings */}
            <div className="section tight profile-settings" style={{ textAlign: 'left' }}>
                <h2>Profile Settings</h2>
                <div className="profile-display-name-input">
                    <label>
                        Display Name
                        <input
                            type="text"
                            name="displayName"
                            value={userDoc.displayName}
                            onChange={handleInputChange}
                            placeholder="Display Name"
                            maxLength={30}
                        />
                    </label>
                </div>
                <div className="profile-image-input">
                    <label>
                        Profile Image URL
                        <input
                            type="text"
                            name="imageURL"
                            value={userDoc.imageURL}
                            onChange={handleInputChange}
                            placeholder="Image URL"
                        />
                    </label>
                </div>
                <div className="profile-email-input">
                    <label>
                        Email
                        <input
                            type="email"
                            name="email"
                            value={userDoc.email}
                            onChange={handleInputChange}
                            placeholder="Email Address"
                        />
                    </label>
                </div>
                <p>To delete your account, click <strong onClick={handleDeleteAccountClicked} style={{ cursor: 'pointer' }}>here</strong>.</p>
                <div style={{ marginTop: '20px', display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                    <Button text={'sign out'} option={'yellow'} onClick={handleSignOutClicked} />
                </div>
            </div>

            {/* Pop Up: Sign Out  */}
            {
                signOutPopUp ? (
                    <div className="signout-pop-up-container">
                        <div className="signout-pop-up">
                            <div className="signout-pop-up-header">
                                <div className="title">
                                    {/* <h2>Channel Preview</h2> */}
                                    <div
                                        className="close pointer"
                                        style={{
                                            backgroundImage: `url(${'https://logowik.com/content/uploads/images/close1437.jpg'})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat'
                                        }}
                                        onClick={handleCloseSignOut}
                                    >
                                    </div>
                                </div>
                            </div>
                            <div className="signout-pop-up-scroll-view">
                                <SignOut />
                            </div>
                        </div>
                    </div>
                ) : null
            }

            {/* Pop Up: Delete Account  */}
            {
                deleteAccountPopUp ? (
                    <div className="signout-pop-up-container">
                        <div className="signout-pop-up">
                            <div className="signout-pop-up-header">
                                <div className="title">
                                    {/* <h2>Channel Preview</h2> */}
                                    <div
                                        className="close pointer"
                                        style={{
                                            backgroundImage: `url(${'https://logowik.com/content/uploads/images/close1437.jpg'})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat'
                                        }}
                                        onClick={handleCloseSignOut}
                                    >
                                    </div>
                                </div>
                            </div>
                            <div className="signout-pop-up-scroll-view">
                                <p>Are you sure you want to <strong>delete your account?</strong></p>
                                <Button text={'Delete'} option={'red'} onClick={handleDeleteThisAccount} />
                                <p style={{ fontSize: 'small' }}>All your data and progress will be deleted.</p>
                            </div>
                        </div>
                    </div>
                ) : null
            }

            <div className="footer-margin">
            </div>
        </div>
    );
};

export default Settings;